import ReactGA from 'react-ga';
import { gaTrackingId } from '../config/app-config.json';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

ReactGA.initialize(gaTrackingId);

const setUserId = userId => ReactGA.set({ userId });

const setPageView = page => {
    ReactGA.set({ page });
    ReactGA.pageview(page);
}

const usePageViews = () => {
    let location = useLocation();
    useEffect(() => { setPageView(location.pathname) }, [location]);
}

export default {
    setUserId,
    setPageView,
    usePageViews
};
